<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="row">
			<div class="col-12">
				<div class="card shadow-lg">
					<div class="card-body">
						<div class="mb-2 float-end">
							<b-button v-b-modal.new-prn size="sm" variant="primary"><i class="mdi mdi-plus"></i> New
								Subscription</b-button>
						</div>
						<div class="clearfix"></div>
						<div class="row">
							<div class="col-sm-12 col-md-6">
								<div id="tickets-table_length" class="dataTables_length">
									<label class="d-inline-flex align-items-center">
										Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
											:options="Options"></b-form-select> entries
									</label>
								</div>
							</div>
							<div class="col-sm-12 col-md-6">
								<div id="tickets-table_filter" class="dataTables_filter text-md-end">
									<label class="d-inline-flex align-items-center">
										Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
											class="form-control form-control-sm ms-2"></b-form-input>
									</label>
								</div>
							</div>
						</div>
						<div class="table-responsive">
							<b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
								:filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
								<template #table-busy>
									<div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
											small></b-spinner> <strong>No Data Found</strong></div>
								</template>
								<template #cell(index)="data">
									{{ data.index + 1 }}
								</template>

								<template #cell(created_at)="data">
									{{ findday(data.item.created_at) }}
								</template>
							</b-table>
						</div>
						<div class="row">
							<div class="col">
								<div class="dataTables_paginate paging_simple_numbers float-end">
									<ul class="pagination pagination-rounded mb-0">
										<b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="new-prn" centered title="New Subscription" title-class="font-18" hide-footer>
			<form @submit.prevent="pay">
				<div class="form-group mb-2">
					<label>Service</label>
					<v-select :options="services" @input="FindProduct" placeholder="Select a Service"
						v-model="service"></v-select>
					<label>Product</label>
					<v-select :options="products" @input="FindPrice" placeholder="Select a Product" v-model="product"></v-select>
					<label>Amount</label>
					<input v-model="amount" type="text" class="form-control" />
					<div class="form-group mb-2">
						<label>Mobile Money Number</label>
						<b-input-group prepend="+256"><input v-model="telephone" placeholder="Enter Telephone" v-mask="'#########'"
								type="text" class="form-control" /></b-input-group>
					</div>
				</div>
				<div class="form-group d-flex justify-content-end">
					<b-button type="button" class="btn w-30" variant="secondary"
						@click="$bvModal.hide('new-prn')">Close</b-button>
					<b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
						Submit</b-button>
				</div>
			</form>
		</b-modal>

		<b-modal id="waiting-confirm" centered title-class="font-18" hide-footer>
			<div class="text-center">
				<b>{{ responseMessage }}</b><br><br>
				<b-spinner class="align-middle" type="grow" style="width: 5rem; height: 5rem;"></b-spinner>
			</div>
			<div class="form-group d-flex justify-content-end">
				<b-button type="button" class="btn w-30" variant="secondary"
					@click="$bvModal.hide('waiting-confirm')">Close</b-button>
			</div>
		</b-modal>

	</Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { subscriptionMethods, subscriptionComputed } from "@/state/helpers";

export default {
	page: {
		title: "Subscriptions",
		meta: [{ name: "description", content: appConfig.description, },],
	},
	components: {
		Layout, PageHeader
	},
	data() {
		return {
			userData: JSON.parse(localStorage.getItem("user")),
			title: "Subscriptions",
			items: [{ text: "Dashboard", to: "/", }, { text: "Subscriptions", active: true, },],
			TotalRows: 1,
			currentPage: 1,
			perPage: 10,
			Options: [10, 50, 100, 150, 200],
			filter: null,
			todoFilter: null,
			filterOn: [],
			sortDesc: true,
			isBusy: true,
			fields: [
				{ key: 'index', label: '#', visible: true },
				{ key: 'id', label: 'ID', visible: false },
				{ key: 'service', label: 'Service', visible: true },
				{ key: 'amount', label: 'Amount', visible: true },
				{ key: 'telephone', label: 'Telephone', visible: true },
			],
			id: '',
			name: '',
			services: ["Software Subscription", "SMS Purchase"], service: "",
			products: [], product: "", amount: "", telephone: "", responseMessage: "",
		};
	},
	computed: {
		...subscriptionComputed,
		List() { return this.subscriptions.length; },
		Fields() { return this.fields.filter(field => field.visible) },
		Items() { return this.subscriptions.map((d) => ({ ...d })) },
		IsBusy() { let a = false; if (this.subscriptions.length > 0) { a = false; } else { a = true; } return a },
	},
	mounted() {
		this.fetchSubscriptions();
		this.TotalRows = this.subscriptions.length;
		this.isBusy = false;
	},
	methods: {
		...subscriptionMethods,
		Filtered(filteredItems) {
			this.TotalRows = filteredItems.length;
			this.currentPage = 1;
		},
		FindProduct() {
			if (this.service == "Software Subscription") {
				this.products = ["Yearly Subscription", "Monthly Subscription"]
			} else {
				this.products = ["Starter Pack - 250 sms", "Premium Pack - 500 sms", "Enterprise Pack - 1000 sms"]
			}
		},
		FindPrice() {
			if (this.product == "Yearly Subscription") {
				this.amount = 500000;
			} else if (this.product == "Monthly Subscription") {
				this.amount = 50000;
			} else if (this.product == "Starter Pack - 2500 sms") {
				this.amount = 10000;
			} else if (this.product == "Premium Pack - 5000 sms") {
				this.amount = 30000;
			} else if (this.product == "Enterprise Pack - 10000 sms") {
				this.amount = 50000;
			} else {
				this.amount = 0;
			}
		},
		async pay() {
			let formData = new FormData();
			formData.append("telephone", this.telephone);
			formData.append("amount", this.amount);
			formData.append("service", this.product);
			let url = "/makesubscription";
			await axios.post(url, formData).then((response) => {
				if (response.data.code == 200) {
					this.responseMessage = response.data.message;
					this.$bvModal.hide('new-prn');
					this.$bvModal.show('waiting-confirm');
					this.interval = setInterval(async () => { await this.ConfirmPayment(response.data.reference); }, 5000 * 5);
				}
			});
		},

		async ConfirmPayment(reference) {
			let formData = new FormData();
			formData.append("reference", reference);
			let url = "/confirmpayment";
			await axios.post(url, formData).then((response) => {
				if (response.status == 200) {
					// this.fetchSchoolClasses();
					if (response.data.code == '200') {
						this.$bvModal.hide('waiting-confirm');
						clearInterval(this.interval);
						this.$swal({ title: 'Success', text: response.data.message, icon: 'success' });
					}
				}
			});
		},
	},
	destroyed() {
		// Clear the interval when the component is destroyed
		clearInterval(this.interval);
	},
};
</script>